<div class="mt-4 mb-4" *ngIf="invoice">
  <ol class="breadcrumb bg-white">
    <li class="breadcrumb-item"><button class="btn btn-sm btn-link" [routerLink]="['/purchase/invoice']">Factures</button></li>
    <li class="breadcrumb-item"><button class="btn btn-sm btn-link" [routerLink]="['/purchase/invoice']" [queryParams]="{supplier: invoice.supplier.name}">{{ invoice.supplier.name }}</button></li>
    <li class="breadcrumb-item active"><button class="btn btn-sm btn-link" disabled>{{ invoice.supplierInvoiceNumber }}</button></li>
  </ol>
</div>

<div class="p-3 bg-white rounded shadow-sm container-fluid" *ngIf="invoice">
  <table class="table table-sm text-center">
    <thead>
      <tr>
        <th>Fournisseur</th>
        <th>Numéro</th>
        <th>Type</th>
        <th>Statut</th>
        <th>Needa</th>
        <th>Compatbilité</th>
        <th>Dates</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>{{ invoice.supplier.name }}</td>
        <td>{{ invoice.supplierInvoiceNumber }}</td>
        <td>
          <invoice-type [invoiceType]="invoice.type"></invoice-type>
        </td>
        <td>
          <invoice-status [status]="invoice.status"></invoice-status>
        </td>
        <td>
          <ng-container *ngIf="needaInvoices">
            <div *ngFor="let needaInvoice of needaInvoices">
              <button class="btn btn-sm btn-link" [routerLink]="['/purchase/invoice', invoice.id, 'needa', needaInvoice]">
                Facture Needa
              </button>
            </div>
          </ng-container>
        </td>
        <td>
          <invoice-accounting-status 
            [invoice]="invoice"
            [quickbookUrl]="quickbookUrl"
          ></invoice-accounting-status>
        </td>
        <td>
          <div>Facture reçu le <strong>{{ invoice.creationTimestamp | date: 'medium' }}</strong></div>
          <div *ngIf="invoice.receivedTimestamp">Réceptionné le <strong>{{ invoice.receivedTimestamp | date: 'medium' }}</strong></div>
        </td>
      </tr>
    </tbody>
  </table>

  <table class="table table-sm table-hover">
    <thead>
      <tr>
        <th>Couverture</th>
        <th>Titre</th>
        <th>ISBN</th>
        <th>Prix de vente</th>
        <th>Quantité commandée</th>
        <th>Quantité facturée</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let detail of invoice.details">
        <td><reference-image [reference]="detail.reference"></reference-image></td>
        <td>
          <div>
            {{ detail.reference.title }}
            <a class="ml-2" [routerLink]="['/inventory/reference', detail.reference.isbn]" target="_blank">
              <i class="bi bi-card-heading"></i>
            </a>
          </div>
          <div>{{ detail.reference.isbn }}</div>
          <div>{{ detail.reference.publisher }}</div>
        </td>
        <td>
          {{ detail.reference.isbn }}
        </td>
        <td>
          <div>{{ detail.reference.supplierReferences[0].retailPrice / 100 | currency }}</div>
          <div *ngIf="detail.costPrice != detail.reference.supplierReferences[0].retailPrice">
            <span class="badge badge-danger">Nouveau prix à {{ detail.costPrice / 100 | currency }}</span>
          </div>
          <div *ngIf="detail.reference.supplierReferences[0].retailPriceOverride">
            <span class="badge badge-warning">Surchargé à {{ detail.reference.supplierReferences[0].retailPriceOverride / 100 | currency }}</span>
          </div>
        </td>
        <td>
          {{ detail.orderedQuantity }}
        </td>
        <td>
          {{ detail.deliveredQuantity }}
        </td>
      </tr>
    </tbody>
  </table>

  <div class="pb-3 d-flex" *ngIf="invoice.status == 'TO_RECEIVE'">
    <button class="btn btn-sm btn-success ml-auto" (click)="receive()">Réceptionner la facture</button>
  </div>
</div>